'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var orderSummaryElement = document.getElementById('orderSummaryValues');
    var marketingConsent = _common2.default.hasMarketingConsent();
    if (orderSummaryElement && marketingConsent && !window.disableEhubClientPush) eHubClientPush();

    if (orderSummaryElement && (_common2.default.hasStatisticsConsent() || marketingConsent) && !window.disableAffiliatePortImplicitPush) {
        affiliatePortPush();
    }

    function affiliatePortPush() {
        try {
            var pushData = JSON.parse(decodeURIComponent(orderSummaryElement.value));
            var sentObject = { 'amount': pushData.amountBase, 'advSub': pushData.orderId };

            // mostly for test environments
            if (window.enableAffiliatePortDebugOutput) {
                console.debug('Affiliate port push data:', sentObject);
            }

            if (typeof _AP_tracker === 'undefined') {
                console.warn('Affiliate port tracker instance is undefined.');
                return;
            }
            // sending to affiliate port
            _AP_tracker.convert(sentObject);
        } catch (e) {
            console.error('Error in pushing Affiliate port data.', e);
        }
    }
    function eHubClientPush() {
        try {
            var pushData = JSON.parse(unescape(orderSummaryElement.value));

            if (pushData.enableOriginalImplementation === false) return;

            var eHubScript = document.createElement('script');
            eHubScript.id = 'ehsjs';
            eHubScript.src = 'https://ehub.cz/system/scripts/sale.js.php';
            eHubScript.async = true;
            eHubScript.defer = true;
            eHubScript.addEventListener('load', function () {
                var eHubOrder = new EhubSale();
                eHubOrder.setCampaignId('ef98c680');
                eHubOrder.setOrderId(pushData.orderId);
                eHubOrder.setOrderAmount(pushData.amountBase);
                eHubOrder.setCurrency(pushData.currency);
                eHubOrder.setCouponCode(pushData.couponCode);
                eHubOrder.setPaymentMethod(pushData.paymentMethod);
                eHubOrder.process();
            });
            document.head.appendChild(eHubScript);
        } catch (e) {
            console.error('Error in pushing eHub data.', e);
        }
    }
};

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/eHubClientPush.js
// module id = 1068
// module chunks = 1